import { ResturantProfileAction } from "../const";
import { ResturantProfileType } from "../Type/ResturantProfile.type";
export const getProfile = (data: ResturantProfileType) => {
    return {
        type: ResturantProfileAction.GET_RESPROFILE,
        payload: data,
    };
};
